/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const demandSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  demandStatusId: z.int(),
  description: z.string().nullish(),
  governanceTier: z.enum(['LIGHTWEIGHT', 'STANDARD', 'HIGH_CONTROL']).nullish(),
  id: z.int(),
  ownerId: z.string().nullish(),
  score: z.number().nullish(),
  targetLoopId: z.int().nullish(),
  title: z.string(),
  updatedAt: z.iso.datetime(),
});
